import { RESOURCE_TYPES } from '../../constants';
export class ResourceValueChecker {
    static isResourceRest(resourceDSL) {
        return resourceDSL.type === RESOURCE_TYPES.rest;
    }
}
